export default function cloneDeep(value){
	return JSON.parse(JSON.stringify(value));
}
